import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NavbarIconsCatalogInstitutions from "../generic-nav-bar/NavbarIconsCatalogInstitutions";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useTracking } from "react-tracking";
import { catalogInstitutionCleanSearchText, catalogInstitutionStartDelete, cleanCatalogInstitutionLevel1, cleanCatalogInstitutionLevel2, cleanSearchingCatalogInstitutionsPaginated, selectCatalogInstitutionLevel1, selectCatalogInstitutionLevel2, selectCatalogInstitutions, startLoadingCatalogInstitutionByParent, startLoadingCatalogInstitutionsByLevel1, startLoadingCatalogInstitutionsNoLevel6, startLoadingCatalogInstitutionsPaginated, startSearchingCatalogInstitutionsPaginated } from "../../app/actions/catalogInstitutionActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import SearchBackCatalogInstitution from "../generic-search/SearchBackCatalogInstitution";
import ReactPaginateComponent from "../generic-ui/ReactPaginateComponent";
import SimpleSelect from "../generic-ui/Select";
import TableCatalogInstitutions from "./TableCatalogInstitutions";

const ID_FORM = "admin-institution";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListCatalogInstitutions = () => {
  debugLogPages(':: ListCatalogInstitutions');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, catalogInstitutionsS, catalogInstitutionsP, totalPagesP, totalPagesS, currentPageS,
    listCatalogInstitutionsLevel1, listCatalogInstitutionsLevel2
  } = useSelector((state) => state.catalogInstitution);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");
  const [catalogInstitutionLevel1, setCatalogInstitutionLevel1] = useState("");
  const [catalogInstitutionLevel2, setCatalogInstitutionLevel2] = useState("");
  const [isDisabledSearchText, setIsDisabledSearchText] = useState(false);
  const [isDisabledFilter, setIsDisabledFilter] = useState(false);

  useEffect(() => {
    dispatch(cleanSearchingCatalogInstitutionsPaginated());
    dispatch(catalogInstitutionCleanSearchText());
    //Load Data
    dispatch(startLoadingCatalogInstitutionsPaginated(pageInitial, itemsPerPage));
    setSearchText("");

    dispatch(startLoadingCatalogInstitutionsNoLevel6())
    
    dispatch(startLoadingCatalogInstitutionsByLevel1(1));
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditCatalogInstitutions", method: "onEditRow", event: "EditCatalogInstitutions-Clicked" });

    dispatch(selectCatalogInstitutions(row));
    if (catalogInstitutionsS?.length > 0) {
      navigate("/admin-institution/edit-institution", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-institution/edit-institution");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteCatalogInstitutions", method: "onDeleteRow", event: "DeleteCatalogInstitutions-Clicked" });
    dispatch(catalogInstitutionStartDelete(row.id));
  };

  const onPageChangeReactPaginate = (pageClick) => {
    const pageClickRP = pageClick && pageClick.selected + 1

    if (catalogInstitutionsS && catalogInstitutionsS.length > 0) {
      dispatch(startSearchingCatalogInstitutionsPaginated(searchText, pageClickRP - 1, itemsPerPage));
    } else {
      dispatch(startLoadingCatalogInstitutionsPaginated(pageClickRP - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (catalogInstitutionsS && catalogInstitutionsS.length > 0) {
      dispatch(startSearchingCatalogInstitutionsPaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingCatalogInstitutionsPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  const handleChangeInstitutionLevel1 = (event) => {
    
    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);
      
      if (event.code === 0) {

        setCatalogInstitutionLevel1(event);

        dispatch(cleanCatalogInstitutionLevel1());

        dispatch(selectCatalogInstitutionLevel1(event));

        setCatalogInstitutionLevel2("");

      } else {

        setCatalogInstitutionLevel1(event);

        dispatch(cleanCatalogInstitutionLevel1());

        dispatch(selectCatalogInstitutionLevel1(event));

        setCatalogInstitutionLevel2("");

        dispatch(startLoadingCatalogInstitutionsPaginated(pageInitial, itemsPerPage, event));

        dispatch(startLoadingCatalogInstitutionByParent(event.id, 2));
      }
    } else {

      setIsDisabledSearchText(false);
      setIsDisabledFilter(false);

      dispatch(cleanCatalogInstitutionLevel1());
      setCatalogInstitutionLevel1("");
      setCatalogInstitutionLevel2("");

      dispatch(startLoadingCatalogInstitutionsPaginated(pageInitial, itemsPerPage));

    }
  };

  const handleChangeInstitutionLevel2 = (event) => {

    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);



      setCatalogInstitutionLevel2(event);

      dispatch(cleanCatalogInstitutionLevel2());

      dispatch(selectCatalogInstitutionLevel2(event));

      dispatch(startLoadingCatalogInstitutionsPaginated(pageInitial, itemsPerPage, event));

      dispatch(startLoadingCatalogInstitutionByParent(event.id, 3));
    } else {
      //setIsDisabledSearchText(false);
      setIsDisabledFilter(false);

      dispatch(cleanCatalogInstitutionLevel2());
      setCatalogInstitutionLevel2("");

      dispatch(startLoadingCatalogInstitutionsPaginated(pageInitial, itemsPerPage, catalogInstitutionLevel1));

    }
  };


  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      
      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
  };

  return (
    <>
      <NavbarIconsCatalogInstitutions page={"listCatalogInstitutions"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="container">
        <div className="row">

          {/* catalogInstitutionId */}
          {/* Level1 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level1`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangeInstitutionLevel1}
                classNamePrefix="select"
                name="catalogInstitutionLevel1"
                value={catalogInstitutionLevel1}
                options={listCatalogInstitutionsLevel1}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />
            </div>
          </div>

          {/* Level2 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level2`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangeInstitutionLevel2}
                classNamePrefix="select"
                name="catalogInstitutionLevel2"
                value={catalogInstitutionLevel2}
                options={listCatalogInstitutionsLevel2}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />

            </div>
          </div>
        </div>
      </div>

      <hr className="line-hr" />

      <SearchBackCatalogInstitution 
        searchText={searchText} 
        setSearchText={setSearchText} 
        itemsPerPage={itemsPerPage} 
        setIsDisabledSearchText={setIsDisabledSearchText}
        isDisabledSearchText={isDisabledSearchText}
        setIsDisabledFilter={setIsDisabledFilter}
        isDisabledFilter={isDisabledFilter}
        />

      {catalogInstitutionsS && catalogInstitutionsS.length > 0 ? (
        <TableCatalogInstitutions data={catalogInstitutionsS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableCatalogInstitutions data={catalogInstitutionsP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <SimpleSelect listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {catalogInstitutionsS && catalogInstitutionsS.length > 0 ? (
          <ReactPaginateComponent
            totalPages={totalPagesS}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChangeReactPaginate}
            currentPage={currentPageS}
            marginPagesDisplayed={5}
          />
        ) : (
          <ReactPaginateComponent
            totalPages={totalPagesP}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChangeReactPaginate}
            currentPage={currentPageS}
            marginPagesDisplayed={5}
          />
        )}
      </div>
    </>
  );
};

export default ListCatalogInstitutions;
